// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { nativeFetch } from '@/lib/utils/nativeFetch';

const SUPABASE_URL = "https://nkrxgmguwqkczuphqcvu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5rcnhnbWd1d3FrY3p1cGhxY3Z1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc1NjE0MTQsImV4cCI6MjA2MzEzNzQxNH0.CicCVZkbpN2kUIFbTaoz73scrAOHMsAOS7ne5iXNMaw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Use native fetch to bypass Lovable's monitoring script that causes DataCloneError
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  global: {
    fetch: nativeFetch,
  },
});